import functions from './functions.js';
import calendar from  './calendar.js';
import Slider from "./Slider";
import {SimpleGuests} from "./simple-guests.js";

$(() => {
    details.init();
});

const details = {
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: '2,0,0', 
        dates: null,
        dateFrom: null,
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    init() {

        if(! $('.page-type-details')[0]) {
            return;
        }

        if($('#booking')[0]) {
            $(window).scroll(e => {
                const offset = $('#booking').offset().top - $('#booking').outerHeight();
    
                $(window).scrollTop() > 200 
                    ? $('.nav-top').addClass('visible') 
                    : $('.nav-top').removeClass('visible');
                
                $(window).scrollTop() > 550 && $(window).scrollTop() < offset 
                    ? $('.nav-bottom').addClass('visible') 
                    : $('.nav-bottom').removeClass('visible');
    
            });
        }

        let unitCardSlider = [];
        $('[id^=unit-card-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            unitCardSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                slidesPerView: 1,
                spacing: 0,
                pager: false
            });
        });

        //modalUnit
        $('[id^=modalUnit]').on('shown.bs.modal', e => {
            let unitModalSlider = [];
            $('[id^=unit-modal-slider]').each((i, elem) => {
                const length = $(elem).find('.keen-slider__slide').length;
                unitModalSlider[i] = new Slider('#' + $(elem).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    slidesPerView: 1,
                    spacing: 0,
                    pager: false
                });
            });
        });


        details.getParams();

        details.params.objectGroupId = $('#booking').attr('data-objectgroupid');
        details.params.objectId = $('#booking').attr('data-objectid');
        details.params.unitId = $('#booking').attr('data-unitid');

        //details.splitCalendarDates($('[name=dates]').val());

        details.calcErrorMessages = $('#booking').attr('data-calcErrorMessages') ? JSON.parse($('#booking').attr('data-calcErrorMessages')) : null;

        if($('[data-calendarconfig]')[0]) {
            details.calendarInit();
        }

        if(details.params.dateFrom && details.params.dateTo) {
            if($('[name="dates"]')[0]._flatpickr) {
                $('[name="dates"]')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            } else if ($('.datepicker,.datepicker-range')[0]) {
                $('.datepicker,.datepicker-range')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            }
           details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
        }

        details.getCalculation();

        if(details.params.guests && $('.simple-guests')[0]) {
            $('.simple-guests').each( (inex, elem) => {
                elem._simpleGuests.setValue(details.params.guests);
            })
        }

        $('[name="guests"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.params.guests = $target.val();
            functions.setUrlData(details.params, true);
        });

        $('[name="dates"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.splitCalendarDates($target.val());
            functions.setUrlData(details.params, true);
        });

        $('.btn-clear-dates').on('click', function (e) {
            $('.total-old').addClass('d-none');
            $('.book-now-btn').addClass('d-none');
            $('.select-dates-text').removeClass('d-none');
            $('[name="dates"]')[0]._flatpickr.setDate([]);
            details.params.dateTo = details.params.dateFrom = null;
            functions.setUrlData(details.params, true);
            details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
        });

        $(window).on('hashchange', e => {
            details.getParams();
            details.getCalculation();
        });


        details.loadReviews();
        details.inquiryInit();

    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 3;
            let page = +$button.data('page') + 1;
            let total = Math.round(+$button.data('total') / perPage);
            
            $.post('/services/reviews/', { language : functions.getLang(), perPage : perPage, page: page, objectId: $button.data('objectid') }).then(response => {
                console.log(response);
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= page) {
                        $button.addClass('d-none');
                    }
                    $(".reviews").append(response.html);
                }
            }).fail(e => {
                console.log(e);
            });
        });
    },
    inquiryInit() {
        $('form#inquiry').on('submit', e => {
            e.preventDefault();

            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            $.each($(e.currentTarget).serializeArray(), function (i, field) {
                params[field.name] = field.value;
            });

            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            grecaptcha.ready(function () {
                grecaptcha.execute('6Lclfu0gAAAAANUqIZ53gAHM2YS0sWiwuATfWq2i', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {

                        $(".modal-body").html(response.data);

                        setTimeout(() => {
                            $('[data-bs-dismiss="modal"]').click();
                        }, 4000);

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }
                    });
                });
            });
        });
    },

    calendarInit() {
        let config = JSON.parse($('[data-calendarconfig]').attr('data-calendarconfig'));

        let defaultDate = $('[data-calendarconfig][data-defaultdate]').attr('data-defaultdate');
        let minDate = $('[data-calendarconfig]').attr('data-mindate');
        /*if( ! details.params.dateFrom && defaultDate) {
            let dates = defaultDate.split(' - ');
            //details.params.dates = defaultDate;
            details.splitCalendarDates(defaultDate);
            defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
        }*/

        calendar.calendar.init(
            $('.datepicker-range-book'),
            {
                availabilityMask : config.availabilityMask,
                minStay : config.minStay,
                translations : config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                minDate: minDate ? minDate : 'today',
                mode: 'range',
                inline: true,
                containerClass : 'details-booking-calendar m-auto m-lg-none'
            },
            details.callbackOnDatesSelected
        );
    },
    callbackOnDatesSelected(from, to) {
        
        $('.calendar-message').removeClass('d-none').text(details.getCalcErrorMessage({type : ! from ? 'selectDates' : 'selectDepartureDate'}));
        if ( to && ! to[1]) {
            $('.btn-booking').addClass('disabled');
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        //details.splitCalendarDates(details.params.dates);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    getCalcErrorMessage(error) {
        if (error && details.calcErrorMessages && details.calcErrorMessages[error.type]) {
            return details.calcErrorMessages[error.type].replace('{$condition}', error.condition);
        }
        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    getCalculation(unitId = null) {

        //console.log(details.params);

        const dateFrom = details.params.dateFrom;
        const dateTo = details.params.dateTo;
        unitId = details.params.unitId;

        if(
            (details.params.objectId || unitId)
            && details.params.guests
            && dateFrom
            && dateTo
            && details.params.objectGroupId
        ) {

            let persons = details.params.guests.split(',');
            $('.guests').text(+persons[0] + +persons[1]);

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + details.params.objectId)
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang()
            )
                .done(response => {

                    if(response.status) {
                        const data = response.data || [];

                        //console.log(data);

                        Object.entries(data).forEach(unit => {
                            const unitId = unit[0];
                            const unitData = unit[1];

                            const $btnBooking = $('.btn-booking[data-unitid=' + unitId + ']');

                            if(details.isBookable(unitData)) {
                                const unitCalc = unitData.calc;

                                const calcItems = unitCalc.items;
                                let priceOld = 0.00;
                                let priceOldEUR = 0.00;
                                let discountTitle = null;
                                let currencySymbol = unitCalc.currencySymbol;
                                let currencySymbolBefore = unitCalc.currencySymbol != 'kn' ? currencySymbol : '';
                                let currencySymbolAfter = unitCalc.currencySymbol == 'kn' ? currencySymbol : '';

                                calcItems.forEach(item => {
                                    // popust za djecu ne ulazi u prikaz discount cijene
                                    if((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                                        priceOld += item.itemTotal;
                                        priceOldEUR += item.itemTotalEUR;
                                    }
                                    if(item.itemType == 'discount') {
                                        discountTitle = item.itemTitle;
                                        if(item.data && item.data.text) {
                                            discountTitle = item.data.text;
                                        }
                                    }
                                });

                                const total = currencySymbolBefore + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',') + ' ' + currencySymbolAfter;
                                const totalEUR = functions.formatMoney(unitCalc.totalEUR, 0, '.', ',');

                                $('.calc-message').addClass('d-none');
                                $('.unit-price-container').removeClass('d-none');

                                if($btnBooking.attr('href')) {
                                    $btnBooking.attr('href',
                                        $btnBooking.attr('href').split('?')[0] +
                                        '?unitId=' + unitId +
                                        '&dateFrom=' + details.params.dateFrom +
                                        '&dateTo=' + details.params.dateTo +
                                        '&guests=' + details.params.guests +
                                        '&numberOfPets=' + details.params.numberOfPets
                                    );
                                }

                                $btnBooking.removeClass('disabled');

                                $('.date-from').text(functions.formatDate(dateFrom, 'dd.mm.yyyy.'));
                                $('.date-to').text(functions.formatDate(dateTo, 'dd.mm.yyyy.'));
                                $('.nights').text(unitCalc.nights);

                                $('.total').text(total);
                                $('.total-converted').text(totalEUR);

                                if (priceOld != unitCalc.total) {
                                    $('.total-old').removeClass('d-none');
                                    $('.total-old').text(currencySymbolBefore + ' ' + functions.formatMoney(priceOld, 0, '.', ',') + ' ' + currencySymbolAfter);
                                } else {
                                    $('.total-old').addClass('d-none');
                                }

                                $('.btn-select-dates').addClass('d-none');

                                $('.no-calculation').addClass('d-none');
                                $('.calculation').removeClass('d-none');

                                $('.from-block').addClass('d-none');
                                $('.total-block').removeClass('d-none');

                                $('.select-dates-text').addClass('d-none');
                                $('.book-now-btn').removeClass('d-none');


                            } else {
                                $('.btn-booking').addClass('disabled');
                                //$('.unit-error-container').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                                $('.calc-message').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                                $('.unit-price-container').addClass('d-none');

                                $('.no-calculation').removeClass('d-none');
                                $('.calculation').addClass('d-none');
                                $('.btn-select-dates').removeClass('d-none');

                                $('.total-block').addClass('d-none');
                                $('.from-block').removeClass('d-none');
                            }

                        });
                    }

                }).fail(function (error) {
                    console.log(error);
                });
        }

        else {
            $('.btn-booking').addClass('disabled');
            $('.no-calculation').removeClass('d-none');
            $('.calculation').addClass('d-none');
            $('.btn-select-dates').removeClass('d-none');

            $('.calc-message').addClass('d-none');
            $('.unit-price-container').removeClass('d-none');

            $('.total-block').addClass('d-none');
            $('.from-block').removeClass('d-none');
        }
    }
}